<template>

</template>

<script>
import { currentId } from '@/services/store';

export default {
  name: 'Store',
  setup() {
    return {
      currentId
    };
  }
};
</script>

<style scoped>

</style>
